import { Mail, Phone } from "lucide-react";
import { useContent } from "../context/SiteContext";
import { Container, PageHero, Empty, Loading } from "../components/site/Common";

export const BEARER_GROUPS = ["Office Bearers", "Vice Presidents", "Joint Secretaries", "Executive Committee"];

const Contact = ({ value, id }) => {
  const isPhone = /^[+\d][\d\s-]{6,}$/.test(value.trim());
  const href = isPhone ? `tel:${value.replace(/[\s-]/g, "")}` : value.includes("@") ? `mailto:${value}` : null;
  const Icon = isPhone ? Phone : Mail;
  const inner = <><Icon className="h-3.5 w-3.5" />{value}</>;
  const cls = "mt-3 text-sm text-slate-600 inline-flex items-center gap-1.5";
  return href ? <a href={href} className={`${cls} hover:text-blue-700`} data-testid={`bearer-contact-${id}`}>{inner}</a> : <p className={cls} data-testid={`bearer-contact-${id}`}>{inner}</p>;
};

export const Person = ({ p }) => (
  <article className="card p-6 border-l-4 !border-l-blue-600" data-testid={`bearer-card-${p.id}`}>
    <p className="text-xs font-bold uppercase tracking-wider text-blue-700" data-testid={`bearer-designation-${p.id}`}>{p.designation}</p>
    <h3 className="mt-2 font-display text-lg font-semibold text-[#0B1F44]" data-testid={`bearer-name-${p.id}`}>{p.name}</h3>
    {p.contact && <Contact value={p.contact} id={p.id} />}
  </article>
);

export default function OfficeBearers() {
  const { items } = useContent("bearers");
  return (
    <>
      <PageHero eyebrow="Leadership" title="Office bearers & committee" text="The office bearers and executive committee who run TDBA's programmes and events." />
      <section className="py-16 bg-slate-50 min-h-[50vh]">
        <Container>
          {!items ? <Loading /> : items.length === 0 ? <Empty>Committee details will be published soon.</Empty> : BEARER_GROUPS.map((g) => {
            const list = items.filter((p) => p.group === g);
            if (!list.length) return null;
            return (
              <div key={g} className="mb-16" data-testid={`bearer-group-${g.toLowerCase().replace(/\s+/g, "-")}`}>
                <h2 className="font-display text-2xl font-bold text-[#0B1F44] mb-6">{g}</h2>
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">{list.map((p) => <Person key={p.id} p={p} />)}</div>
              </div>
            );
          })}
        </Container>
      </section>
    </>
  );
}
